import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';
import { useHistory } from 'react-router-dom';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "none",
    padding: "0px",
    minWidth: "90%",
    maxWidth: "90%",
  },
};

function Vendors() {
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [text, setText] = useState('');
  const [value] = useDebounce(text, 1000);
  const history = useHistory();

  async function getPurchaseOrder(typeValue) {
    setIsLoadingOn(true);
    const tempData = await getData(`inventory/getVendor?vendorName=${typeValue || ''}`);
    setIsLoadingOn(false);
  
    if (tempData?.statusCode === 200) {
      const records = tempData?.data?.records;
      if (Array.isArray(records)) {
        setOrderList(records);
      } else {
        setOrderList([]); // fallback if records is undefined or not an array
      }
    } else {
      setOrderList([]); // ensure orderList is not undefined
      Swal.fire({
        title: "Error!",
        text: tempData?.data?.errors?.msg || "Something went wrong!!!"
      });
    }
  }
  

  // useEffect(() => {
  //   // Initial load - fetch all purchase orders
  //   getPurchaseOrder('');
  // }, []);
  
  // Debounced search
  useEffect(() => {
    getPurchaseOrder(value); // if empty string, returns all
  }, [value]);

  const filterPurchaseOrder = (e) => {
    setText(e.target.value);
  }


  return (
    <div className="purchaseOrderSec purchaseListSec">
      <div>
        {isLoadingOn ? <Loader /> : ""}

        {/* {Array.isArray(orderList) && orderList.length > 0 && ( */}
          <div className="filter mb-3">
            <div className="row">
              <div className="col-sm-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search in Vendors"
                  onChange={(e) => filterPurchaseOrder(e)}
                />
              </div>
            </div>
          </div>
        {/* )} */}
        <div className="d-flex justify-content-between align-items-center">
          <h4>Vendors</h4>
          <div>
            {/* <button className="btn btn-outline-primary transitbtnbg">In Transit Receives</button> */}
            <button className="btn btn-primary mx-2" onClick={() => history.push("/addNewVendor")}>+ New</button>
            {/* <button className="btn btn-light">⋮</button> */}
          </div>
        </div>
          <div className="purchaseorderTable">
            <div className="table-container">
              <div className="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }} className="checkbox-cell"><input type="checkbox" /></th>
                      <th style={{ width: "300px"}}>VENDOR NAME</th>
                      <th style={{ width: "200px" }}>DISPLAY NAME</th>
                      <th style={{ width: "200px" }}>COMPANY NAME</th>
                      <th style={{ width: "200px" }}>EMAIL</th>
                      <th style={{ width: "200px" }}>WORK PHONE</th>
                      <th style={{ width: "200px" }}>PAYABLES (BYC)</th>
                      <th style={{ width: "200px" }}>UNUSED CREDITS (BYC)</th>

                    </tr>
                  </thead>
                  <tbody>
                    {orderList.map((item, index) => {
                      return (
                        <tr key={index} className="table-row">
                          <td className="checkbox-cell"><input type="checkbox" /></td>
                          <td><Link to={`/vendorDetails/${item?.id}`} className="vendor-name">{item?.vendorName || "-"}</Link></td>
                          <td>{item?.displayName || "-"}</td>
                          <td>{item?.companyName || "-"}</td>
                          <td>{item?.email || "-"}</td>
                          <td>{item?.phoneNumber || "-"}</td>
                          <td>{item?.status || "-"}</td>
                          <td>{item?.received || "-"}</td>
                        </tr>
                      )
                    })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        


      </div>
    </div>
  );
}

export default Vendors;
